/* Smart Basics Paws — global.js
   Dispatch countdown (SAST), drawers, AJAX cart, header, announcement bar, WhatsApp, how-it-works, formula finder.
   Vanilla JS, no dependencies. */
(function () {
  'use strict';
  var SBP = (window.SBP = window.SBP || {});
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var strings = SBP.strings || {};

  /* ------------------------------------------------------------------ money */
  SBP.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = parseInt(cents.replace(/[^\d-]/g, ''), 10);
    cents = Math.round(Number(cents) || 0);
    var fmt = String(format || SBP.moneyFormat || 'R {{amount}}').replace(/<[^>]*>/g, '');
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function withDelims(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var fixed = (n / 100).toFixed(precision).split('.');
      var whole = fixed[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (fixed[1] ? decimal + fixed[1] : '');
    }
    var m = fmt.match(re);
    var key = m ? m[1] : 'amount';
    var v;
    switch (key) {
      case 'amount_no_decimals': v = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': v = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = withDelims(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = withDelims(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': v = withDelims(cents, 2, "'", '.'); break;
      case 'amount_with_period_and_space_separator': v = withDelims(cents, 2, ' ', '.'); break;
      default: v = withDelims(cents, 2);
    }
    return fmt.replace(re, v);
  };

  /* ------------------------------------------------------------------ toast */
  SBP.toast = function (msg, ms) {
    var t = $('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.hidden = true; }, ms || 3500);
  };

  /* ------------------------------------------------------------------ layout measurements */
  function measure() {
    var ann = $('.section-announcement');
    var hdr = $('.section-header');
    var root = document.documentElement.style;
    root.setProperty('--announce-h', (ann ? ann.offsetHeight : 0) + 'px');
    root.setProperty('--header-h', (hdr ? hdr.offsetHeight : 0) + 'px');
  }
  if ('ResizeObserver' in window) {
    /* ResizeObserver reports each element once after the first layout, so there is no need to force a
       synchronous layout here with an up-front measure() (that cost ~30ms on a mid-range phone). */
    var ro = new ResizeObserver(measure);
    $$('.section-announcement, .section-header').forEach(function (el) { ro.observe(el); });
  } else {
    measure();
    window.addEventListener('resize', measure);
  }

  /* ------------------------------------------------------------------ header: hide on scroll down */
  (function () {
    var wrap = $('.section-header');
    var header = wrap && $('[data-sticky]', wrap);
    if (!header || header.getAttribute('data-sticky') !== 'scroll-up') return;
    var lastY = null; /* read lazily on the first scroll so page load doesn't force a layout */
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (lastY === null) lastY = y;
        var down = y > lastY + 4;
        var up = y < lastY - 4;
        if (down && y > 260 && !document.querySelector('dialog[open]')) wrap.classList.add('is-hidden');
        else if (up || y < 120) wrap.classList.remove('is-hidden');
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  })();

  /* ------------------------------------------------------------------ announcement rotation (< 1100px) */
  (function () {
    var items = $$('[data-announce-item]');
    if (items.length < 2) return;
    var mq = window.matchMedia('(min-width: 1100px)');
    var i = 0;
    function schedule() {
      var ms = parseInt(items[i].getAttribute('data-announce-duration'), 10) || 5000;
      setTimeout(next, ms);
    }
    function next() {
      if (!mq.matches && !document.hidden) {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }
      schedule();
    }
    schedule();
  })();

  /* ------------------------------------------------------------------ dispatch & delivery (SAST) */
  (function () {
    var D = SBP.dispatch || {};
    var OFFSET = 2 * 3600 * 1000; /* South Africa: UTC+2, no daylight saving */
    var DAY = 86400000;
    var cutoff = Number(D.cutoffHour) || 12;
    var minDays = Math.max(0, Number(D.minDays) || 2);
    var maxDays = Math.max(minDays, Number(D.maxDays) || minDays);
    var holidays = {};
    String(D.holidays || '').split(/[\s,;]+/).forEach(function (s) {
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) holidays[s] = true;
    });
    var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var DOW_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    /* Dates below are "SAST calendar days" stored as UTC-midnight Date objects. */
    function key(d) { return d.toISOString().slice(0, 10); }
    function isWorkday(d) {
      var w = d.getUTCDay();
      return w !== 0 && w !== 6 && !holidays[key(d)];
    }
    function addWorkdays(d, n) {
      var x = new Date(d.getTime());
      var added = 0;
      var guard = 0;
      while (added < n && guard++ < 60) {
        x = new Date(x.getTime() + DAY);
        if (isWorkday(x)) added++;
      }
      return x;
    }
    function compute(nowMs) {
      var s = new Date(nowMs + OFFSET);
      var today = new Date(Date.UTC(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate()));
      var day = today;
      for (var i = 0; i < 30; i++) {
        if (isWorkday(day)) {
          var cutoffMs = day.getTime() + cutoff * 3600000 - OFFSET;
          if (nowMs < cutoffMs) {
            return {
              today: i === 0,
              daysAhead: Math.round((day.getTime() - today.getTime()) / DAY),
              dispatchDay: day,
              cutoffMs: cutoffMs,
              arriveMin: addWorkdays(day, minDays),
              arriveMax: addWorkdays(day, maxDays)
            };
          }
        }
        day = new Date(day.getTime() + DAY);
      }
      return null;
    }
    function fmtDate(d) { return DOW[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MON[d.getUTCMonth()]; }
    function fmtRange(a, b) {
      if (a.getTime() === b.getTime()) return fmtDate(a);
      if (a.getUTCMonth() === b.getUTCMonth()) return DOW[a.getUTCDay()] + ' ' + a.getUTCDate() + ' – ' + fmtDate(b);
      return fmtDate(a) + ' – ' + fmtDate(b);
    }
    function fmtLeft(ms) {
      var t = Math.max(0, Math.floor(ms / 1000));
      var d = Math.floor(t / 86400);
      var h = Math.floor((t % 86400) / 3600);
      var m = Math.floor((t % 3600) / 60);
      var sec = t % 60;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      if (d > 0) return d + 'd ' + h + 'h ' + pad(m) + 'm';
      if (h > 0) return h + 'h ' + pad(m) + 'm ' + pad(sec) + 's';
      return m + 'm ' + pad(sec) + 's';
    }
    function dayLabel(st) {
      if (st.daysAhead === 1) return strings.tomorrow || 'tomorrow';
      if (st.daysAhead < 7) return DOW_LONG[st.dispatchDay.getUTCDay()];
      return 'on ' + fmtDate(st.dispatchDay);
    }

    var lastMode = null;
    function tick() {
      var st = compute(Date.now());
      if (!st) return;
      var mode = st.today ? 'today' : 'later';
      if (mode !== lastMode || tick.force) {
        $$('[data-dispatch]').forEach(function (root) {
          $$('[data-dispatch-static]', root).forEach(function (el) { el.hidden = true; });
          $$('[data-dispatch-when]', root).forEach(function (el) { el.hidden = el.getAttribute('data-dispatch-when') !== mode; });
        });
        lastMode = mode;
        tick.force = false;
      }
      /* Only show a countdown when it is meaningful: before today's cut-off, or within 18h of the next one. */
      var soon = st.today || (st.cutoffMs - Date.now()) < 18 * 3600000;
      $$('[data-dispatch-timer], [data-dispatch-soon]').forEach(function (el) { if (el.hidden === soon) el.hidden = !soon; });
      var left = fmtLeft(st.cutoffMs - Date.now());
      $$('[data-dispatch-countdown]').forEach(function (el) { if (el.textContent !== left) el.textContent = left; });
      var dl = dayLabel(st);
      $$('[data-dispatch-day]').forEach(function (el) { el.textContent = dl; });
      var arrive = fmtRange(st.arriveMin, st.arriveMax);
      $$('[data-delivery-date]').forEach(function (el) { el.textContent = arrive; });
    }
    SBP.dispatchState = function () { return compute(Date.now()); };
    SBP.dispatchTick = function () { tick.force = true; tick(); };
    if (document.querySelector('[data-dispatch]')) {
      tick();
      setInterval(function () { if (!document.hidden) tick(); }, 1000);
    }
  })();

  /* ------------------------------------------------------------------ dialogs (drawers, search) */
  function openDialog(dlg, opener) {
    if (!dlg || dlg.open) return;
    dlg._opener = opener || document.activeElement;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    document.documentElement.classList.add('lock-scroll');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { dlg.classList.add('is-open'); });
    });
    var focusTarget = $('input[type="search"]', dlg);
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 60);
    document.dispatchEvent(new CustomEvent('sbp:dialog', { detail: { open: true, id: dlg.id } }));
  }
  function closeDialog(dlg) {
    if (!dlg || !dlg.open || dlg._closing) return;
    dlg._closing = true;
    dlg.classList.remove('is-open');
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      dlg._closing = false;
      if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
      if (!document.querySelector('dialog[open]')) document.documentElement.classList.remove('lock-scroll');
      if (dlg._opener && typeof dlg._opener.focus === 'function' && document.contains(dlg._opener)) {
        try { dlg._opener.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
      }
      document.dispatchEvent(new CustomEvent('sbp:dialog', { detail: { open: false, id: dlg.id } }));
    }
    var panel = $('.drawer__panel, .modal__panel', dlg);
    if (panel) panel.addEventListener('transitionend', finish, { once: true });
    setTimeout(finish, 380);
  }
  SBP.openDialog = openDialog;
  SBP.closeDialog = closeDialog;

  function wireDialog(dlg) {
    if (dlg._wired) return;
    dlg._wired = true;
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); closeDialog(dlg); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) closeDialog(dlg); });
  }
  $$('dialog[data-drawer]').forEach(wireDialog);

  /* ------------------------------------------------------------------ cart */
  function jsonHeaders() {
    return { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  }
  function checkoutUrl() {
    return String((SBP.routes && SBP.routes.cart) || '/cart').replace(/\/cart\/?$/, '') + '/checkout';
  }
  SBP.checkoutUrl = checkoutUrl;

  SBP.cart = {
    busy: false,
    add: function (items) {
      var self = this;
      return fetch(SBP.routes.cartAdd + '.js', {
        method: 'POST',
        headers: jsonHeaders(),
        body: JSON.stringify({ items: items, sections: 'cart-drawer', sections_url: window.location.pathname })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok || r.data.status) {
            throw new Error(r.data.description || r.data.message || strings.cartError);
          }
          self.applySections(r.data.sections);
          document.dispatchEvent(new CustomEvent('sbp:cart:added', { detail: r.data }));
          return r.data;
        });
    },
    change: function (key, quantity) {
      var self = this;
      return fetch(SBP.routes.cartChange + '.js', {
        method: 'POST',
        headers: jsonHeaders(),
        body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok || r.data.status) throw new Error(r.data.description || r.data.message || strings.cartError);
          self.applySections(r.data.sections);
          if (typeof r.data.item_count === 'number') self.updateCount(r.data.item_count);
          document.dispatchEvent(new CustomEvent('sbp:cart:changed', { detail: r.data }));
          return r.data;
        });
    },
    refresh: function () {
      var self = this;
      return fetch(window.location.pathname + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (sections) { self.applySections(sections); });
    },
    applySections: function (sections) {
      if (!sections || !sections['cart-drawer']) return;
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-inner]');
      var current = document.querySelector('[data-cart-drawer-inner]');
      if (fresh && current) current.parentNode.replaceChild(document.importNode(fresh, true), current);
      if (fresh) {
        var n = parseInt(fresh.getAttribute('data-item-count'), 10);
        if (!isNaN(n)) this.updateCount(n);
      }
      if (SBP.dispatchTick) SBP.dispatchTick();
    },
    updateCount: function (n) {
      $$('[data-cart-count]').forEach(function (el) {
        var changed = el.textContent !== String(n);
        el.textContent = n;
        el.hidden = n === 0;
        if (changed && n > 0) {
          el.classList.remove('is-bump');
          void el.offsetWidth;
          el.classList.add('is-bump');
        }
      });
      $$('[data-cart-label]').forEach(function (el) { el.setAttribute('aria-label', 'Cart (' + n + ')'); });
    },
    open: function () {
      var d = document.getElementById('CartDrawer');
      if (d && SBP.cartType !== 'page') openDialog(d);
      else window.location.href = SBP.routes.cart;
    }
  };

  /* ------------------------------------------------------------------ delegated clicks */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var opener = t.closest('[data-drawer-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (dlg) { e.preventDefault(); wireDialog(dlg); openDialog(dlg, opener); }
      return;
    }

    var closer = t.closest('[data-drawer-close]');
    if (closer) {
      var parentDlg = closer.closest('dialog');
      if (parentDlg) { e.preventDefault(); closeDialog(parentDlg); }
      return;
    }

    /* same-page #anchor links inside a drawer: close first, then scroll (scroll is locked while open) */
    var dlgLink = t.closest('dialog[data-drawer] a[href*="#"]');
    if (dlgLink) {
      var url = new URL(dlgLink.href, window.location.href);
      if (url.pathname === window.location.pathname && url.hash.length > 1) {
        e.preventDefault();
        closeDialog(dlgLink.closest('dialog'));
        setTimeout(function () {
          var dest = document.getElementById(decodeURIComponent(url.hash.slice(1)));
          if (dest) dest.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (history.replaceState) history.replaceState(null, '', url.hash);
        }, 400);
        return;
      }
    }

    var cartToggle = t.closest('[data-cart-toggle]');
    if (cartToggle) {
      var drawer = document.getElementById('CartDrawer');
      if (drawer && SBP.cartType !== 'page') { e.preventDefault(); wireDialog(drawer); openDialog(drawer, cartToggle); }
      return;
    }

    var qtyBtn = t.closest('[data-cart-qty]');
    if (qtyBtn) {
      e.preventDefault();
      if (SBP.cart.busy) return;
      var inner = qtyBtn.closest('[data-cart-drawer-inner]');
      SBP.cart.busy = true;
      if (inner) inner.classList.add('is-busy');
      SBP.cart.change(qtyBtn.getAttribute('data-cart-qty'), Math.max(0, parseInt(qtyBtn.getAttribute('data-qty-to'), 10) || 0))
        .catch(function (err) { SBP.toast(err.message || strings.cartError); })
        .then(function () {
          SBP.cart.busy = false;
          var cur = document.querySelector('[data-cart-drawer-inner]');
          if (cur) cur.classList.remove('is-busy');
        });
      return;
    }

    var upsellBtn = t.closest('[data-upsell-add]');
    if (upsellBtn) {
      e.preventDefault();
      var box = upsellBtn.closest('[data-upsell]');
      var sel = box && box.querySelector('[data-upsell-variant]');
      if (!sel || !sel.value || SBP.cart.busy) return;
      SBP.cart.busy = true;
      upsellBtn.classList.add('is-loading');
      SBP.cart.add([{ id: Number(sel.value), quantity: 1 }])
        .catch(function (err) { SBP.toast(err.message || strings.cartError); })
        .then(function () { SBP.cart.busy = false; upsellBtn.classList.remove('is-loading'); });
      return;
    }

    var tierLink = t.closest('[data-select-tier]');
    if (tierLink && document.querySelector('[data-buybox]')) {
      document.dispatchEvent(new CustomEvent('sbp:select-tier', { detail: { handle: tierLink.getAttribute('data-select-tier') } }));
      var href = tierLink.getAttribute('href') || '';
      if (href.charAt(0) !== '#') {
        e.preventDefault();
        var bb = document.querySelector('[data-buybox]');
        bb.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    var pick = t.closest('[data-pick-formula]');
    if (pick && document.querySelector('[data-buybox]')) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('sbp:select-formula', { detail: { index: parseInt(pick.getAttribute('data-pick-formula'), 10) } }));
      var target = document.querySelector('[data-buybox] [data-formula-picker]:not([hidden])') || document.querySelector('[data-buybox]');
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    var pageQty = t.closest('[data-page-qty]');
    if (pageQty) {
      var input = pageQty.parentNode.querySelector('[data-page-qty-input]');
      if (input) {
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(pageQty.getAttribute('data-page-qty'), 10));
        submitCartPage(input.form);
      }
    }
  });

  /* cart page: auto-update quantities */
  var cartPageTimer;
  function submitCartPage(form) {
    if (!form) return;
    clearTimeout(cartPageTimer);
    form.classList.add('is-busy');
    cartPageTimer = setTimeout(function () {
      var hidden = document.createElement('input');
      hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
      form.appendChild(hidden);
      form.submit();
    }, 450);
  }
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-page-qty-input]')) submitCartPage(e.target.form);
    if (e.target.closest('[data-autosubmit]') && e.target.tagName === 'SELECT') e.target.form.submit();
  });

  /* ------------------------------------------------------------------ WhatsApp: mention the product being viewed */
  (function () {
    var link = $('[data-wa-link]');
    var wa = SBP.whatsapp || {};
    if (!link || !wa.number) return;
    var cfgEl = $('[data-buybox-config]');
    var msg = wa.greeting || 'Hi!';
    if (cfgEl && /\/products\//.test(window.location.pathname)) {
      try {
        var cfg = JSON.parse(cfgEl.textContent);
        if (cfg.productTitle) msg += ' about the ' + cfg.productTitle + ': ' + window.location.origin + window.location.pathname;
      } catch (e) { /* ignore */ }
    }
    link.href = 'https://wa.me/' + String(wa.number).replace(/\D/g, '') + '?text=' + encodeURIComponent(msg);
  })();

  /* ------------------------------------------------------------------ WhatsApp: step aside for Add to cart
     While an Add to cart / Buy it now button is on screen, tuck the floating chat button away so it can
     never sit on top of the price or the button. It comes back as soon as the buttons scroll away. */
  (function () {
    var float = $('.wa-float');
    var targets = $$('[data-buybox] [data-atc], [data-buybox] [data-buy-now]');
    if (!float || !targets.length || !('IntersectionObserver' in window)) return;
    var onScreen = [];
    var mq = window.matchMedia('(max-width: 989px)'); /* phones + tablets, where the buttons run full width */
    function update() { float.classList.toggle('is-tucked', mq.matches && onScreen.length > 0); }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var at = onScreen.indexOf(en.target);
        if (en.isIntersecting && at === -1) onScreen.push(en.target);
        if (!en.isIntersecting && at > -1) onScreen.splice(at, 1);
      });
      update();
    });
    targets.forEach(function (t) { io.observe(t); });
    if (mq.addEventListener) mq.addEventListener('change', update);
  })();

  /* ------------------------------------------------------------------ How it works stepper */
  function initSteps(scope) {
  $$('[data-steps]', scope).forEach(function (root) {
    if (root._steps) return;
    root._steps = true;
    var btns = $$('[data-step]', root);
    var frames = $$('[data-step-frame]', root);
    if (!btns.length) return;
    var items = btns.map(function (b) { return b.closest('.hiw__step'); });
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var auto = root.getAttribute('data-autoplay') === 'true' && !reduce;
    var MS = 5200;
    var idx = 0;
    var timer = null;
    var userStopped = false;
    root.style.setProperty('--step-ms', MS + 'ms');
    function go(i) {
      idx = i;
      items.forEach(function (li, j) {
        li.classList.toggle('is-active', j === i);
        li.classList.remove('is-playing');
        btns[j].setAttribute('aria-pressed', j === i ? 'true' : 'false');
      });
      frames.forEach(function (f, j) { f.classList.toggle('is-active', j === i); });
    }
    function play() {
      if (!auto || userStopped) return;
      clearTimeout(timer);
      var li = items[idx];
      li.classList.remove('is-playing');
      void li.offsetWidth;
      li.classList.add('is-playing');
      timer = setTimeout(function () { go((idx + 1) % btns.length); play(); }, MS);
    }
    function stop() {
      clearTimeout(timer);
      items.forEach(function (li) { li.classList.remove('is-playing'); });
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { userStopped = true; stop(); go(i); });
    });
    if (auto && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) play(); else stop(); });
      }, { threshold: 0.35 }).observe(root);
    }
  });
  }
  initSteps(document);

  /* ------------------------------------------------------------------ Formula finder */
  function initFinder(scope) {
  $$('[data-finder]', scope).forEach(function (root) {
    if (root._finder) return;
    root._finder = true;
    var chips = $$('[data-finder-chip]', root);
    var cards = $$('[data-finder-card]', root);
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var wasOn = chip.getAttribute('aria-pressed') === 'true';
        chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        cards.forEach(function (c) { c.classList.remove('is-match', 'is-dim'); });
        if (wasOn) return;
        chip.setAttribute('aria-pressed', 'true');
        var i = chip.getAttribute('data-finder-chip');
        var match = null;
        cards.forEach(function (c) {
          var hit = c.getAttribute('data-finder-card') === i;
          c.classList.add(hit ? 'is-match' : 'is-dim');
          if (hit) match = c;
        });
        if (match) match.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    });
  });
  }
  initFinder(document);

  /* ------------------------------------------------------------------ theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    initSteps(e.target);
    initFinder(e.target);
    $$('dialog[data-drawer]', e.target).forEach(wireDialog);
    if (SBP.dispatchTick) SBP.dispatchTick();
    measure();
  });
  document.addEventListener('shopify:section:unload', function () {
    $$('.sticky-atc.is-owner').forEach(function (el) { el.remove(); });
    document.documentElement.style.setProperty('--sticky-atc-h', '0px');
  });

  /* ------------------------------------------------------------------ bfcache: reset busy states */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      SBP.cart.busy = false;
      $$('.is-loading').forEach(function (el) { el.classList.remove('is-loading'); });
      if (document.getElementById('CartDrawer')) SBP.cart.refresh().catch(function () {});
    }
  });
})();
